export const getMissionHtmlId = (airtableRecordId: string) => `m-${airtableRecordId}`;

export const getSiteHtmlId = (customerId: string, siteId: string) => `p-${customerId}-${siteId}`;

export const getDateHtmlId = (date: string) => `d-${date.substring(0, 10)}`;
